import * as React from 'react';

import { useTranslation } from 'react-i18next';

import pic_one from '@assets/images/welcome/quest_guide_one.png';
import pic from '@assets/images/welcome/quest_guide_pic.png';
import pic_two from '@assets/images/welcome/quest_guide_two.png';

import { Button } from '@components/button';

import * as Styled from './quest-guide.styled.ts';

type OwnProps = {
	onClickNext: () => void;
	onClickPrevious: () => void;
};

const QuestGuide: React.FC<OwnProps> = ({ onClickPrevious, onClickNext }) => {
	const { t } = useTranslation(['main', 'welcome']);

	return (
		<Styled.Wrapper>
			<Styled.WrapperGroup>
				<Styled.Content>
					<Styled.Title>
						{t('welcome:quest_guide')} <span>{t('welcome:quest_guide_hg')}</span>
					</Styled.Title>
					<Styled.Info>
						<Styled.Group>
							<Styled.GroupImage src={pic_one} alt='Quest Guide One' />
							<Styled.ObjTitle>{t('welcome:obj_one_title')}</Styled.ObjTitle>
							<Styled.Desc>{t('welcome:obj_one_desc')}</Styled.Desc>
						</Styled.Group>
						<Styled.Group>
							<Styled.GroupImage src={pic_two} alt='Quest Guide Two' />
							<Styled.ObjTitle>{t('welcome:obj_two_title')}</Styled.ObjTitle>
							<Styled.Desc>{t('welcome:obj_two_desc')}</Styled.Desc>
							<Styled.Obj>
								<Styled.ObjTitle>{t('welcome:steps')}</Styled.ObjTitle>
								<Styled.DescList>
									<Styled.DescItem>{t('welcome:steps_one')}</Styled.DescItem>
									<Styled.DescItem>{t('welcome:steps_two')}</Styled.DescItem>
									<Styled.DescItem>{t('welcome:steps_three')}</Styled.DescItem>
								</Styled.DescList>
							</Styled.Obj>
						</Styled.Group>
					</Styled.Info>
					<Styled.ButtonGroup>
						<Button onClick={onClickPrevious} color='dark'>
							{t('back')}
						</Button>
						<Button onClick={onClickNext} color='primary'>
							{t('next')}
						</Button>
					</Styled.ButtonGroup>
				</Styled.Content>
				<Styled.ImageWrapper>
					<Styled.Image src={pic} alt='intro' />
				</Styled.ImageWrapper>
			</Styled.WrapperGroup>
		</Styled.Wrapper>
	);
};

export default QuestGuide;
